<template>
  <div v-if="canAssegnaAct" class="panoramica-assegna-actions">

    <v-select
      v-model="selected"
      :items="squadreDropdown"
      item-text="name"
      item-value="id"
      item-disabled="disabled"
      :menu-props="{ contentClass: 'asta-assegna-squadre-menu' }"
      dense
      outlined
      hide-details
      dark
      class="panoramica-assegna-select"
      label="Squadra"
      no-data-text="Nessuna squadra disponibile"
    >
      <template #selection="{ item }">
        <div class="squadra-dropdown-selection">
          <v-avatar size="25" class="mr-1">
            <img :src="item.pic" />
          </v-avatar>
          <span class="squadra-dropdown-name">{{ item.name }}</span>
        </div>
      </template>

      <template #item="{ item }">
        <v-list-item-avatar>
          <img :src="item.pic" />
        </v-list-item-avatar>
        <v-list-item-content class="squadra-dropdown-item-content">
          <v-list-item-title
            v-text="item.name"
            class="squadra_name squadra-option-name"
          ></v-list-item-title>
          <v-list-item-subtitle
            v-if="item.disabledReason"
            class="squadra-disabled-reason"
          >
            {{ item.disabledReason }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>

    <v-text-field
      :value="offerta"
      dense
      outlined
      readonly
      hide-details
      dark
      label="Costo"
      append-icon="edit"
      class="panoramica-assegna-costo"
      @click="showNumpad()"
      @click:append="showNumpad()"
      @keydown.prevent
    ></v-text-field>

    <v-btn
      v-if="canAnnullaSelezione"
      small
      text
      rounded
      color="white"
      :loading="processingAnnulla"
      :disabled="processing"
      @click="annullaSelezione()"
    >
      Annulla
    </v-btn>

    <v-btn
      large
      outlined
      rounded
      color="white"
      :disabled="processing"
      @click="scarta()"
    >
      Scarta
    </v-btn>

    <v-btn
      large
      rounded
      color="accent"
      class="navy--text"
      :loading="loading"
      :disabled="
        selected == null || offerta == null || squadraDisabled(selected)
      "
      @click="assegna()"
    >
      Assegna
    </v-btn>

    <v-alert
      dense
      text
      color="error"
      class="panoramica-assegna-error mb-0"
      v-model="error"
    >
      Offerta {{ errorValue }} non valida. Min: {{ minOfferta }} - Max:
      {{ maxOfferta }}
    </v-alert>
  </div>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import astaAssegnaActionsMixin from "../../js/mixins/astaAssegnaActionsMixin";

export default {
  name: "asta-assegna-header-actions",
  mixins: [mixins, toast, astaAssegnaActionsMixin],
  mounted() {
    db.on("numpadSubmitted", this.setOffertaDaNumpad);
  },
  destroyed() {
    db.off("numpadSubmitted", this.setOffertaDaNumpad);
  },
};
</script>

<style lang="scss" scoped>
.panoramica-assegna-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 420px;
  min-width: 220px;
  max-width: 680px;
  flex-wrap: wrap;
}

.panoramica-assegna-select {
  flex: 1 1 150px;
  min-width: 120px;
}

.panoramica-assegna-costo {
  flex: 0 0 92px;
  max-width: 92px;
}

.panoramica-assegna-select::v-deep .v-input__slot,
.panoramica-assegna-costo::v-deep .v-input__slot {
  min-height: 30px;
}

.panoramica-assegna-select::v-deep fieldset,
.panoramica-assegna-costo::v-deep fieldset {
  border-width: 2px;
}

.panoramica-assegna-select::v-deep .v-label,
.panoramica-assegna-costo::v-deep .v-label,
.panoramica-assegna-select::v-deep input,
{
  font-size: 11px;
}

.panoramica-assegna-costo::v-deep input
{
  font-size: 13px;
  font-weight: 700;
}

.squadra-dropdown-selection {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.squadra-dropdown-name,
.squadra_name,
.squadra-option-name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.squadra-dropdown-item-content {
  min-width: 0;
}

.squadra-disabled-reason {
  color: var(--v-error-base) !important;
  display: block;
  font-size: 11px;
  line-height: 1.2;
  margin-top: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panoramica-assegna-error {
  flex-basis: 100%;
  font-size: 11px;
}

@media (max-width: 600px) {
  .panoramica-assegna-actions {
    flex-basis: 100%;
    max-width: none;
  }

  .panoramica-assegna-select {
    flex-basis: 155px;
  }
}
</style>
